import { z } from "zod/v4";

import { OfferLikeObjectSchema } from "../../../../../dtos/offers";

export const PluginOfferDiscountSchema_2024_05_05 =
  OfferLikeObjectSchema.extend({
    // offerProducts: PluginOfferProductSchema.array().default([]),
  });

export type PluginOfferDiscountType_2024_05_05 = z.infer<
  typeof PluginOfferDiscountSchema_2024_05_05
>;
